import { useRecordsFieldOptionsConfig } from "../../../../../RecordsFieldOptionsConfig/context.js";
import { toOptionsWithExisting } from "../../../../../RecordsFieldOptionsConfig/utils.js";
/* empty css                 */
import { EditableRecordField } from "../../../EditableRecordField/index.js";
import "react";
import { Button, Constants, Icon, Label, useContainerDimensionsContext } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { MdChangeCircle } from "react-icons/md";
//#region src/modules/Records/shared/RecordModal/components/InfoTab/PersonRecordFields.tsx
function PersonRecordFields({ canEdit, onFieldChange, record }) {
	const { viewport: { width: mainWidth } } = useContainerDimensionsContext();
	const config = useRecordsFieldOptionsConfig();
	let layout = "Xxl";
	if (mainWidth < Constants.Breakpoint.Sm.width) layout = "Sm";
	else if (mainWidth < Constants.Breakpoint.Xl.width) layout = "Xl";
	return /* @__PURE__ */ jsxs("div", {
		className: "grid grid-cols-6",
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-3": layout === "Xxl",
					"col-span-6": layout !== "Xxl"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Name"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "name",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.name
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-3": layout === "Xxl",
					"col-span-6": layout !== "Xxl"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Alias / Nickname"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "alias",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.alias
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Race"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "race",
					fieldType: "select",
					options: toOptionsWithExisting(config?.person.race, record.fields.race),
					onComplete: onFieldChange,
					value: record.fields.race
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({ "col-span-3": layout === "Sm" }),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Gender"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "gender",
					fieldType: "select",
					options: toOptionsWithExisting(config?.person.gender, record.fields.gender),
					onComplete: onFieldChange,
					value: record.fields.gender
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({ "col-span-3": layout === "Sm" }),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Height"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "height",
					fieldType: "select",
					options: toOptionsWithExisting(config?.person.height, record.fields.height),
					onComplete: onFieldChange,
					value: record.fields.height
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({ "col-span-3": layout === "Sm" }),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Weight"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "weight",
					fieldType: "number",
					onComplete: onFieldChange,
					value: record.fields.weight
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({ "col-span-3": layout === "Sm" }),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Eyes"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "eyes",
					fieldType: "select",
					options: toOptionsWithExisting(config?.person.eyes, record.fields.eyes),
					onComplete: onFieldChange,
					value: record.fields.eyes
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({ "col-span-3": layout === "Sm" }),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Hair"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "hair",
					fieldType: "select",
					options: toOptionsWithExisting(config?.person.hair, record.fields.hair),
					onComplete: onFieldChange,
					value: record.fields.hair
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({ "col-span-3": layout === "Sm" }),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: canEdit && !!onFieldChange ? /* @__PURE__ */ jsx(Button, {
						className: "w-full",
						onClick: () => onFieldChange({
							fieldName: "approxAge",
							value: !record.fields.approxAge
						}),
						subtle: true,
						size: "xs",
						children: /* @__PURE__ */ jsxs("div", {
							className: "flex grow items-center text-left",
							children: [/* @__PURE__ */ jsxs("div", {
								className: "text-color-subtle trackin-wide grow font-normal",
								children: [/* @__PURE__ */ jsx("span", { children: "Age " }), /* @__PURE__ */ jsx("span", {
									className: "text-color-subtle italic",
									children: record.fields.approxAge ? "approx" : "exact"
								})]
							}), /* @__PURE__ */ jsx(Icon, {
								Icon: MdChangeCircle,
								size: "xs"
							})]
						})
					}) : /* @__PURE__ */ jsxs("span", { children: [/* @__PURE__ */ jsx("span", { children: "Age " }), /* @__PURE__ */ jsx("span", {
						className: "text-color-subtle italic",
						children: record.fields.approxAge ? "approx" : "exact"
					})] })
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "age",
					fieldType: "number",
					onComplete: onFieldChange,
					value: record.fields.age
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "DOB"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "dob",
					fieldType: "datetime",
					onComplete: onFieldChange,
					value: record.fields.dob
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "SSN"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "ss",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.ss
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "ID #"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "idNumber",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.idNumber
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "ID State / Authority"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "idAuthority",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.idAuthority
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Address"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "streetAddress",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.streetAddress
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "City"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "locality",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.locality
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "State"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "region",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.region
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Phone"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "phone",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.phone
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Email"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "email",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.email
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Criminal Record #"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "criminalId",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.criminalId
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Criminal Authority / Agency"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "criminalAuthority",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.criminalAuthority
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "col-span-6",
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Additional Info"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "additional",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.additional
				})]
			})
		]
	});
}
//#endregion
export { PersonRecordFields };

//# sourceMappingURL=PersonRecordFields.js.map